import { render, staticRenderFns } from "./title-text.vue?vue&type=template&id=b73bfdb6&scoped=true"
import script from "./title-text.vue?vue&type=script&lang=js"
export * from "./title-text.vue?vue&type=script&lang=js"
import style0 from "./title-text.vue?vue&type=style&index=0&id=b73bfdb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73bfdb6",
  null
  
)

export default component.exports